import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getAuthoringGlobalDemands = api(() =>
    query(
        gql`
            query GetAuthoringGlobalDemands {
                getAuthoringGlobalDemands {
                    name
                    id
                    description
                    group
                    purpose
                }
            }
        `,
        {},
        { returns: "getAuthoringGlobalDemands" }
    )
)
